<template>
    <div class="bg-white">
        <div
            class="mx-auto grid max-w-3xl grid-cols-1 gap-x-8 gap-y-16 py-16 sm:grid-cols-2 xl:max-w-none xl:grid-cols-3"
            x-max="1"
        >
            <div
                v-for="(date, mIndex) in monthsInActiveYear"
                :key="`month-${mIndex}`"
            >
                <CalendarMonth
                    :monthDate="date"
                    size="mini"
                    :show-full-weeks="false"
                    :active-past-dates="false"
                />
            </div>
        </div>
    </div>
</template>
<script>
import { mapState, mapActions } from 'pinia';
import { useCalendarStore } from '@/store/calendar';

import CalendarMonth from '@/components/calendar/views/month.vue';

export default {
    name: 'CalendarYear',
    props: {
        size: {
            type: String,
            default: 'full', // full | mini
        },
    },
    components: {
        CalendarMonth,
    },
    data: () => ({}),
    watch: {
        activeDate() {
            this.getEvents();
        },
    },
    computed: {
        ...mapState(useCalendarStore, [
            'activeDate',
            'monthsInActiveYear',
            'activeYear',
            'preloadedYear',
        ]),
    },
    methods: {
        ...mapActions(useCalendarStore, ['setDateRange', 'getEvents']),
    },
    mounted() {},
};
</script>
